import { render, staticRenderFns } from "./SplitPagos.vue?vue&type=template&id=4cb9ffc0&scoped=true"
import script from "./SplitPagos.vue?vue&type=script&lang=js"
export * from "./SplitPagos.vue?vue&type=script&lang=js"
import style0 from "./SplitPagos.vue?vue&type=style&index=0&id=4cb9ffc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb9ffc0",
  null
  
)

export default component.exports